module.exports = __webpack_public_path__ + "static/media/bg_resetSucces.8017e279.svg";